import ReactModal from 'react-modal';
import cn from 'classnames';
import { CloseIcon_24 } from 'assets/icons';
import styles from './Modal.module.css';

export type ModalProps = ReactModal.Props & {
  contentClassName?: string;
  hasCloseButton?: boolean;
  disabled?: boolean;
};

export const Modal = ({
  children,
  className,
  contentClassName,
  hasCloseButton = true,
  disabled,
  ...restOfProps
}: ModalProps): JSX.Element => (
  <ReactModal
    {...restOfProps}
    overlayClassName={styles.modal}
    className={styles.modal__overlay}
  >
    <div className={cn(styles.modalSheet, className)}>
      {hasCloseButton && (
        <button
          title={'Close'}
          className={styles.modalSheet__closeButton}
          onClick={restOfProps.onRequestClose}
          disabled={disabled}
        >
          <CloseIcon_24 />
        </button>
      )}
      <div className={contentClassName}>{children}</div>
    </div>
  </ReactModal>
);
